import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import urls from '@/ws/apiUrl.js';
import commonMethods from '@/common/common-methods/commonMethods.js';
Vue.use(Vuex);
let _this = new Vue({});
export default new Vuex.Store({
    state: {
        // 表格页参数
        tablePageParams: {
            page_name: '', // 页面名称(英文，表示页面key，唯一值，可用于本地缓存的key)
            page_title: '', // 页面标题(中文，页面标题组件的内容，表示当前页的名字)
            page_title_navs: [], // 页面标题选项卡数据(通过选中项获取对应的表格数据)
            table_filtrates: {
                column: false,
                captureColumn: false,
                issueColumn: false,
                search: false
            }, // 表格筛选项(当前表格需要的筛选功能组)
            table_titles: [], // 表格表头数据(当前表格需要的表头数据)
            table_operations: [], // 表格操作栏数据(当前表格需要的操作栏功能组)
            table_api: '', // 表格请求接口
            table_api_params: {}, // 表格请求接口所需参数
            table_list: [], // 表格列表数据
            table_page_params: {
                current_page: 1,
                limit: 10,
                total: 0 // 表格数据总数
            }, // 表格分页参数缓存
        },
        // 路径导航数据
        navList: [],
        // 栏目目录数据
        columnList: [],
        // 角色列表
        roleList: [],
        // 操作栏状态
        operationStatus: [],
        // 楼层导航
        levelList: [],
        // 默认头像
        defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    },
    mutations: {
        /**
         * @function setPageKey 设置页面key名
         * @param {*} state 
         * @param {*} res 
         */
        setPageKey(state, res) {
            state.tablePageParams.page_name = res;
            window.sessionStorage.setItem('pagekey', res);
        },
        /**
         * @function setTablePageParams 设置表格当前页参数
         * @param {*} state 
         * @param { object } res 表格页参数
         */
        setTablePageParams(state, res) {
            // 设置页面key
            let key = state.tablePageParams.page_name = res.pageParams.page_name;
            if(res.flag) {
                // 设置页面标题选项卡
                if(res.pageParams.page_title_navs && res.pageParams.page_title_navs.length > 0) {
                    state.tablePageParams.page_title_navs = res.pageParams.page_title_navs;
                }
                // 设置表格所需筛选项
                if(res.pageParams.table_filtrates) {
                    Object.keys(state.tablePageParams.table_filtrates).forEach(el => {
                        state.tablePageParams.table_filtrates[el] = res.pageParams.table_filtrates[el] ? true : false;
                    });
                }
                state.tablePageParams.table_list = [];
                // 获取页面名称、表头和表格操作栏
                switch (key) {
                    case 'captureSet':
                        state.tablePageParams.page_title = '抓取设置';
                        state.tablePageParams.table_titles = [
                            { prop: 'name', label: '栏目' },
                            { prop: 'push_time', label: '推送时间' },
                            { prop: 'get_at', label: '抓取时间' },
                            { prop: 'last_get_at', label: '最新抓取时间' }
                        ];
                        state.tablePageParams.table_operations = [
                            { icon: 'icon-dianji', name: '立即抓取', method_name: 'nowCapture' },
                            { icon: 'icon-bianji', name: '抓取设置', method_name: 'captureSetEdit' },
                            { icon: 'icon-wenzhang', name: '文章列表', method_name: 'captureArticleList' }
                        ];
                        break;
                    case 'grabArticleList': // 抓取设置-文章列表
                        state.tablePageParams.page_title = '文章列表';
                        state.tablePageParams.table_titles = [
                            { prop: 'title', label: '标题', width: 500 },
                            { prop: 'created_at', label: '抓取时间' },
                            { prop: 'source', label: '来源' },
                            { prop: 'author', label: '作者' }
                        ];
                        state.tablePageParams.table_operations = [
                            { icon: 'icon-bianji', name: '编辑', methodName: 'articleEdit' },
                            { icon: 'icon-shanchu', name: '删除', methodName: 'deleteItem' }
                        ];
                        break;
                    case 'captureIssue':
                        state.tablePageParams.page_title = '抓取发布';
                        state.tablePageParams.table_titles = [
                            { prop: 'name', label: '抓取栏目' },
                            { prop: 'releaseCloumns', label: '发布栏目' }
                        ];
                        state.tablePageParams.table_operations = [
                            { icon: 'icon-bianji', name: '添加发布位置', method_name: 'addIssue' }
                        ];
                        break;
                    case 'originalAudit':
                    case 'originalSet':
                        state.tablePageParams.page_title = '原创设置';
                        state.tablePageParams.table_titles = [
                            { prop: 'title', label: '标题', width: '400' },
                            { prop: 'article_type', label: '类型' },
                            { prop: 'source', label: '来源' },
                            { prop: 'author', label: '作者' },
                            { prop: 'user.roles.name', label: '发布者角色' },
                        ];
                        state.tablePageParams.table_operations = [
                            { icon: 'icon-bianji', name: '编辑', method_name: 'toEdit' },
                            { icon: 'icon-wenzhang', name: '推送列表', method_name: 'toIssueList' },
                            { icon: 'icon-shanchu', name: '删除', method_name: 'deleteItem' }
                        ];
                        break;
                    case 'mpWeiXinArticle':
                    case 'issueManage':
                        state.tablePageParams.page_title = key === 'issueManage' ? '发布管理' : '公众号文章';
                        state.tablePageParams.table_titles = [
                            { prop: 'name', label: '栏目', width: '400' },
                            { prop: 'name', label: '公众号名称' },
                            { prop: 'articles', label: '文章(篇)' },
                            { prop: 'read', label: '阅读(次)' },
                            { prop: 'fans', label: '粉丝(人)' },
                            { prop: 'collect', label: '收藏(次)' },
                            { prop: 'new_push_time', label: '最新发布时间' }
                        ];
                        state.tablePageParams.table_operations = [
                            { icon: 'icon-wenzhang', name: '文章列表', method_name: 'toArticleList' }
                        ];
                        break;
                    default:
                        break;
                }
            } else {
                state.tablePageParams = res.pageParams;
            }
            console.log('tablePageParams>>>', state.tablePageParams)
            window.sessionStorage.setItem(key, JSON.stringify(state.tablePageParams));
        },
        /**
         * @function setNavData 设置路径导航数据方法
         * @param {*} state 
         * @param { object } res 
         */
        setNavData(state, res) {
            let data = res.data, flag = res.flag;
            if(data) {
                if(flag) {
                    state.navList.push(data);
                } else {
                    if(data.length > 0) {
                        state.navList = data;
                    } else {
                        state.navList = [];
                        state.navList.push(data);
                    }
                }
            } else {
                state.navList = [];
            }
            window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
        },
        /**
         * @function deleteNavItem 删除最后一个路径导航项
         * @param {*} state 
         * @param {*} res 
         */
        deleteNavItem(state, res) {
            if(res) {
                state.navList.pop();
                window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
            }
        },
        /**
         * @function removeNavItem 移出点击项之后的项
         */
        removeNavItem(state, res) {
            state.navList.splice(res.index + 1, state.navList.length);
            window.sessionStorage.setItem('navList', JSON.stringify(state.navList));
        },
        /**
         * @function setColumnData 设置栏目目录数据
         * @param {*} state 
         * @param { Array } res 
         */
        setColumnData(state, res) {
            state.columnList = res;
            window.sessionStorage.setItem('columnList', JSON.stringify(res));
        },
        /**
         * @function setRoleData 设置角色数据
         * @param {*} state 
         * @param { Array } res 
         */
        setRoleData(state, res) {
            state.roleList = res;
            window.sessionStorage.setItem('roleList', JSON.stringify(res));
        },
        /**
         * @function setLevelData 设置楼层导航数据
         * @param {*} state 
         * @param {*} res 
         */
        setLevelData(state, res) {
            state.levelList = res;
            window.sessionStorage.setItem('levelList', JSON.stringify(res));
        }
    },
    actions: {
        /**
         * @function getColumnData 获取栏目列表数据
         * @param {*} context 
         * @param {*} payload 
         */
        getColumnData(context, payload) {
            axios.get(urls.columnList).then(res => {
                let list = res.data.result;
                context.state.columnList = list;
                window.sessionStorage.setItem('columnList', JSON.stringify(list));
            });
        },
        /**
         * @function getRoleData 获取角色列表数据
         * @param {*} context 
         * @param {*} payload 
         */
        getRoleData(context, payload) {
            axios.get(urls.roleList).then(res => {
                let list = res.data.result;
                context.state.roleList = list;
                window.sessionStorage.setItem('roleList', JSON.stringify(list));
            });
        },
        /**
         * @function getTableData 获取表格数据
         * @param {*} context 
         * @param {*} payload 
         */
        getTableData(context, payload) {
            console.log(context, payload, 111111);
            // 页面key值，表格请求url，请求所需参数
            let key = context.state.tablePageParams.page_name;
            if(payload.table_api) {
                context.state.tablePageParams.table_api = payload.table_api;
            }
            context.state.tablePageParams.table_api_params = payload.table_api_params;
            
            // 设置表格当前页，每页数据数
            context.state.tablePageParams.table_page_params.current_page = payload.table_api_params.page;
            context.state.tablePageParams.table_page_params.limit = payload.table_api_params.limit;
            // 请求数据
            console.log('context.state.tablePageParams.table_api_params', context.state.tablePageParams.table_api_params)
            axios.get(context.state.tablePageParams.table_api, {
                params: context.state.tablePageParams.table_api_params
            }).then(res => {
                console.log('tableList>>>', res);
                let result = res.data.result, data = result.data;
                // 设置表格总数
                context.state.tablePageParams.table_page_params.total = result.total;
                // 根据页面标题名称判断当前表格数据需要处理的项
                switch (key) {
                    case 'captureIssue':
                        if(data.length > 0) {
                            for(let i = 0; i < data.length; i++) {
                                let release = data[i].release;
                                if(release.length > 0) {
                                    let cup = [];
                                    for(let j = 0; j < release.length; j++) {
                                        let column = release[j].get_column.name;
                                        cup.push(column);
                                    }
                                    data[i]['releaseCloumns'] = cup.join('、');
                                }
                            }
                        }
                        break;
                    case 'originalAudit':
                    case 'originalSet':
                        if(data.length > 0) {
                            for(let i = 0; i < data.length; i++) {
                                data[i]['article_type'] = data[i].type === 'original' ? '原创' : (
                                    data[i].type === 'reprint' ? '转载' : ''
                                );
                            }
                        }
                        break;
                    case 'issueManage':
                        break;
                    default:
                        break;
                }
                // 设置表格数据
                context.state.tablePageParams.table_list = data;
                // 设置当前表格页缓存参数
                console.log('vuexparams>>>', context.state.tablePageParams);
                window.sessionStorage.setItem(key, JSON.stringify(context.state.tablePageParams));
            });
            // 设置当前页获取缓存的key值
            window.sessionStorage.setItem('pagekey', key);
        }
    },
    modules: {
    }
});


// WEBPACK FOOTER //
// ./src/vuex/store.js